<p>dynamic-sql-column-adder works!</p>

<div style="padding: 1rem;">
    <h3></h3>
  <input
    type="text"
    [(ngModel)]="userInput"
    placeholder="Enter an SQL table name you would like to add to pp_table_info"
  />
  <button (click)="onSubmit()">Submit</button>
</div>
